// @flow
// import * as Localization from 'expo-localization'
import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  useEffect,
} from 'react'

import themes from '../themes'

const LocalPreferenceContext = createContext()
export const useLocalPreference = () => useContext(LocalPreferenceContext)

type Props = {
  children: any,
}
export const LocalPreferenceProvider = ({ children }: Props) => {
  // console.log('Localization: ', Localization)
  const [theme, setTheme] = useState()
  const context = useMemo(
    () => ({
      theme,
      setTheme,
    }),
    [theme],
  )
  useEffect(() => {
    if (!theme) {
      setTheme(themes.default)
    }
  }, [theme])


  return (
    <LocalPreferenceContext.Provider value={context}>
      {children}
    </LocalPreferenceContext.Provider>
  )
}
